import React, { useState } from 'react';

interface TabContentData {
  id: string;
  tabTitle: string | React.ReactNode;
  tabContent: React.ReactNode;
}

interface TabContentsProps {
  className?: string;
  dataTabs: TabContentData[];
  defaultTab?: string;
}

export const TabContents: React.FC<TabContentsProps> = ({ 
  className = '', 
  dataTabs = [], 
  defaultTab = '' 
}) => {
  const [visibleTab, setVisibleTab] = useState(defaultTab);

  return (
    <div className={`mz-tabs ${className}`}>
      <div className="mz-tabs-menu">
        <div className="mz-tabs-menu-container">
          <div className="mz-tabs-menu-inner">
            {
              dataTabs.map((item, index) =>
                <a
                  onClick={() => setVisibleTab(item.id)}
                  key={item.id}
                  className={`mz-tabs-tab interactive ${visibleTab === item.id ? 'active' : ''}`}
                  data-tab_target={index}
                  data-tab-name={item.tabTitle}
                >
                  {item.tabTitle}
                </a>
              )
            }
          </div>
        </div>
        <div className="mz-tabs-menu--left"><i className="mz-svg mz-svg--grey mz-svg-chevron mz-svg--rotate180"></i></div>
        <div className="mz-tabs-menu--right"><i className="mz-svg mz-svg--grey mz-svg-chevron"></i></div>
      </div>

      <div className="mz-tabs-container">
        {
          dataTabs.map((item, index) => (
            <div key={item.id} className={`mz-container ${visibleTab === item.id ? 'active' : ''}`} data-tab_target={index} >
              {item.tabContent}
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default TabContents;
